/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { combineReducers } from 'redux';
import { ReduxUtils } from '@spm/core';
import { FETCH_GET_GENDER_EMAIL_ADDRESS, POST_MODIFY_EMAIL_ADDRESS } from './actionTypes';

/**
 * Updates the details in the 'ACESUserInfo' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const fetchGetGenderEmailAddressReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, FETCH_GET_GENDER_EMAIL_ADDRESS);

/**
 * Updates the indicator of creation of details in the 'ACESUserInfo' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingFetchGetGenderEmailAddressReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, FETCH_GET_GENDER_EMAIL_ADDRESS);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const fetchGetGenderEmailAddressErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, FETCH_GET_GENDER_EMAIL_ADDRESS);

/**
 * Updates the details in the 'ACESUserInfo' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const postModifyEmailAddressReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, POST_MODIFY_EMAIL_ADDRESS);

/**
 * Updates the indicator of creation of details in the 'ACESUserInfo' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingPostModifyEmailAddressReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, POST_MODIFY_EMAIL_ADDRESS);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const postModifyEmailAddressErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, POST_MODIFY_EMAIL_ADDRESS);

const reducers = combineReducers({
  fetchGetGenderEmailAddress: fetchGetGenderEmailAddressReducer,

  isFetchingFetchGetGenderEmailAddress: isFetchingFetchGetGenderEmailAddressReducer,
  fetchGetGenderEmailAddressError: fetchGetGenderEmailAddressErrorReducer,

  postModifyEmailAddress: postModifyEmailAddressReducer,

  isFetchingPostModifyEmailAddress: isFetchingPostModifyEmailAddressReducer,
  postModifyEmailAddressError: postModifyEmailAddressErrorReducer,
});

export default { reducers };
